import { ISolicitudDocumentoModel } from "../../interfaces/solicitud/documento/ISolicitudDocumentModel";
import { ISolicitudPersonaValidarModel } from "../../interfaces/solicitud/personal/ISolicitudPersonaValidarModel";
import { SolicitudDocumentoModel } from "../documento/SolicitudDocumentoModel";

export class SolicitudPersonaValidarModel implements ISolicitudPersonaValidarModel {
    idSolicitud: number;
    codigoSolicitud: string;
    idSolicitudPersona: number;    
    documentos: ISolicitudDocumentoModel[];
    comentarios: string;
    idEstado: number;

    constructor(){
        this.idSolicitud = 0;
        this.codigoSolicitud = '';
        this.idSolicitudPersona = 0;
        this.documentos = new Array<SolicitudDocumentoModel>();
        this.comentarios = '';
        this.idEstado = 0;
    }
}